import { Injectable, inject } from '@angular/core';

import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { UserOddsFormatSettingsService } from '@frontend/sports/user/feature';

import { NativePrice } from './native-price';

@Injectable({ providedIn: 'root' })
export class NativePriceFormatComparerService {
    private readonly userOddsFormatSettingsService = inject(UserOddsFormatSettingsService);

    lessThan(price: NativePrice, other: NativePrice): boolean {
        switch (this.userOddsFormatSettingsService.oddsFormat) {
            case OddsDisplayFormat.UK:
                return price.fraction.lessThan(other.fraction);
            case OddsDisplayFormat.US:
                return price.americanOdds.lessThan(other.americanOdds);
            default:
                return price.odds.lessThan(other.odds);
        }
    }

    greaterThan(price: NativePrice, other: NativePrice): boolean {
        switch (this.userOddsFormatSettingsService.oddsFormat) {
            case OddsDisplayFormat.UK:
                return price.fraction.greaterThan(other.fraction);
            case OddsDisplayFormat.US:
                return price.americanOdds.greaterThan(other.americanOdds);
            default:
                return price.odds.greaterThan(other.odds);
        }
    }

    greaterThanOrEqualTo(price: NativePrice, other: NativePrice): boolean {
        switch (this.userOddsFormatSettingsService.oddsFormat) {
            case OddsDisplayFormat.UK:
                return price.fraction.greaterThanOrEqualTo(other.fraction);
            case OddsDisplayFormat.US:
                return price.americanOdds.greaterThanOrEqualTo(other.americanOdds);
            default:
                return price.odds.greaterThanOrEqualTo(other.odds);
        }
    }

    isEqual(price: NativePrice, other: NativePrice): boolean {
        switch (this.userOddsFormatSettingsService.oddsFormat) {
            case OddsDisplayFormat.UK:
                return price.fraction.equals(other.fraction);
            case OddsDisplayFormat.US:
                return price.americanOdds.equals(other.americanOdds);
            default:
                return price.odds.equals(other.odds);
        }
    }
}
